import { Input } from '@/components/ui/input';
import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';
import { FieldComponentProps } from './types';

const FieldView = ({ value }: { value?: string | null }) => {
  if (value === null || value === undefined || value === '') {
    return <p className="text-muted-foreground">-</p>;
  }
  return <p>{String(value)}</p>;
};

export const TextField: React.FC<FieldComponentProps> = ({
  formMode,
  controllerField,
  field,
}) => {
  if (formMode === 'loading') {
    return <Skeleton className="h-8 w-full" />;
  }

  if (formMode === 'edit') {
    return (
      <Input
        {...controllerField}
        placeholder={field.meta.placeholder}
        className="h-8 px-2 py-1 text-sm"
      />
    );
  }

  return <FieldView value={controllerField.value} />;
};
